var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex" },
      [
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.dialogShow,
              width: "760px",
              "before-close": _vm.handleClose,
              modal: true,
              "show-close": false,
              "append-to-body": true,
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogShow = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.title)),
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "el-icon-close pointer",
                  on: { click: _vm.handleClose },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.showCrud
              ? _c(
                  "div",
                  { staticClass: "flex-between mb14" },
                  [
                    _c("div", { staticStyle: { width: "90px" } }, [
                      _vm._v("引用实体："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.edit,
                          placeholder: "请选择",
                          size: "small",
                          filterable: "",
                        },
                        on: { change: _vm.getlistData },
                        model: {
                          value: _vm.id,
                          callback: function ($$v) {
                            _vm.id = $$v
                          },
                          expression: "id",
                        },
                      },
                      _vm._l(_vm.options, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.table_name, value: item.id },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.table_name) +
                                  "(" +
                                  _vm._s(item.table_name_en) +
                                  ")"
                              ),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "container" },
              [
                _c("el-col", { staticClass: "search-p", attrs: { span: 24 } }, [
                  this.type !== "module" && this.type !== "view"
                    ? _c("div", { staticClass: "tree-box" }, [
                        _c("div", { staticClass: "title-num" }, [
                          _vm._v(
                            _vm._s(_vm.name) +
                              "（" +
                              _vm._s(_vm.list ? _vm.list.length : 0) +
                              "）"
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.list && _vm.list.length > 0
                          ? _c(
                              "div",
                              { staticClass: "mt14 box" },
                              _vm._l(_vm.list, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "item mb10 over-text",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleClick(item, "id")
                                      },
                                    },
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "iconfont",
                                      class: _vm.ids.includes(item.id)
                                        ? "icontongyong-gouxuanxuanzhongtubiao"
                                        : " iconweigouxuan",
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(item.field_name) +
                                        "\n                "
                                    ),
                                    _vm.showCrud
                                      ? _c("span", [
                                          _vm._v(
                                            "(" +
                                              _vm._s(item.field_name_en) +
                                              ")"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              [
                                _c("default-page", {
                                  attrs: { index: 14, "min-height": 220 },
                                }),
                              ],
                              1
                            ),
                      ])
                    : _c("div", { staticClass: "molude-box" }, [
                        _c("div", { staticClass: "title-num" }, [
                          _vm._v(
                            _vm._s(_vm.name) +
                              "（" +
                              _vm._s(_vm.totalNumber) +
                              "）"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "num mt14 mb10" }, [
                          _vm._v("系统字段"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-wrap" },
                          _vm._l(
                            _vm.min == 5
                              ? _vm.crudInfo.systemListField
                              : _vm.crudInfo.systemField,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item mb10 over-text",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClick(
                                        item,
                                        "field_name_en"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont",
                                    class: _vm.ids.includes(item.field_name_en)
                                      ? "icontongyong-gouxuanxuanzhongtubiao"
                                      : " iconweigouxuan",
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.field_name)
                                  ),
                                  _vm.type !== "module"
                                    ? _c("span", [
                                        _vm._v(
                                          "(" + _vm._s(item.field_name_en) + ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "num mt14 mb10" }, [
                          _vm._v("自定义字段"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-wrap" },
                          _vm._l(
                            _vm.min == 5
                              ? _vm.crudInfo.customListField
                              : _vm.crudInfo.customField,
                            function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "item mb10 over-text",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleClick(
                                        item,
                                        "field_name_en"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    staticClass: "iconfont",
                                    class: _vm.ids.includes(item.field_name_en)
                                      ? "icontongyong-gouxuanxuanzhongtubiao"
                                      : " iconweigouxuan",
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.field_name) +
                                      " "
                                  ),
                                  _vm.type !== "module"
                                    ? _c("span", [
                                        _vm._v(
                                          "(" + _vm._s(item.field_name_en) + ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "select-box" }, [
                  _c("div", { staticClass: "title flex-between" }, [
                    _c("span", { staticClass: "title-num" }, [
                      _vm._v("已展示字段（"),
                      _c("span", { staticClass: "doc" }, [
                        _vm._v(
                          _vm._s(_vm.selectList ? _vm.selectList.length : 0)
                        ),
                      ]),
                      _vm.max > 0
                        ? _c("span", [_vm._v("/" + _vm._s(_vm.max))])
                        : _vm._e(),
                      _vm._v("）"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "empty", on: { click: _vm.restFn } },
                      [_vm._v("清空")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.selectList
                    ? _c(
                        "div",
                        { staticClass: "list-box" },
                        [
                          _c(
                            "draggable",
                            {
                              attrs: {
                                "chosen-class": "chosen",
                                "force-fallback": "true",
                                group: "people",
                                animation: "1000",
                              },
                              model: {
                                value: _vm.selectList,
                                callback: function ($$v) {
                                  _vm.selectList = $$v
                                },
                                expression: "selectList",
                              },
                            },
                            _vm._l(_vm.selectList, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "select-item" },
                                [
                                  _c("div", { staticClass: "left over-text" }, [
                                    _c("i", {
                                      staticClass:
                                        "icon iconfont icontuodong item-drag",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.field_name)
                                      ),
                                      item.field_name_en &&
                                      _vm.type !== "module"
                                        ? _c("span", [
                                            _vm._v(
                                              " (" +
                                                _vm._s(item.field_name_en) +
                                                ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "right-box" }, [
                                    _vm.showCrud && item.field_name_en !== "id"
                                      ? _c("span", {
                                          staticClass: "el-icon-close",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(
                                                item,
                                                _vm.type == "module" ||
                                                  _vm.type == "view"
                                                  ? "field_name_en"
                                                  : "id"
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.handleClose(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("public.cancel")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.handleConfirm },
                  },
                  [_vm._v(_vm._s(_vm.$t("public.ok")))]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }